import { find } from '@execonline-inc/collections';
import { Maybe } from 'maybeasy';
import { Task } from 'taskarian';
import { MissingLinkError } from '../Links';
import { Link, Rel } from '../Resource/Types';

export type { MissingLinkError };

export function findLink(rel: Rel, links: ReadonlyArray<Link>): Maybe<Link>;
export function findLink(rel: Rel): (links: ReadonlyArray<Link>) => Maybe<Link>;
export function findLink(rel: Rel, links?: ReadonlyArray<Link>) {
  const finder = find<Link>((l) => l.rel === rel);
  return typeof links === 'undefined' ? finder : finder(links);
}

/**
 * @deprecated Use the `useFindLinkBy` hook or `findLinkBy` from the root `Fetch` or `Links` module.
 */
export const findSelfLink = findLink('self');

export function findLinkT(rel: Rel, links: ReadonlyArray<Link>): Task<MissingLinkError, Link>;
export function findLinkT(rel: Rel): (links: ReadonlyArray<Link>) => Task<MissingLinkError, Link>;
export function findLinkT(rel: Rel, links?: ReadonlyArray<Link>) {
  const doit = (links: ReadonlyArray<Link>) =>
    findLink(rel, links).cata({
      Nothing: () => Task.fail<MissingLinkError, Link>({ kind: 'missing-link-error', rel }),
      Just: (link) => Task.succeed<MissingLinkError, Link>(link),
    });
  return typeof links === 'undefined' ? doit : doit(links);
}
